<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<a id="title13"></a>
<div class="tp-author"><strong class="b">SHARON KENDRICK</strong></div>
<div class="tp-title"><em class="i"><strong class="b">Getting Even</strong></em></div>
<div class="illustype_image"><div class="image"><img alt="e9781459262027_i0003.jpg" src="e9781459262027_i0003.jpg"/></div></div>
<div class="p-c-br"><span>TORONTO • NEW YORK • LONDON <br/>AMSTERDAM • PARIS • SYDNEY • HAMBURG <br/>STOCKHOLM • ATHENS • TOKYO • MILAN <br/>MADRID • WARSAW • BUDAPEST • AUCKLAND</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459262027_tp01.vue?32e48372